module.exports = __webpack_public_path__ + "static/media/like.0e2a45e0.svg";